import React from 'react';
import LinkedInIcon from "./resources/Linkedin.png";
// import InstagramIcon from './resources/Instagram.png';
// import FacebookIcon from './resources/Facebook.png';
// import TwitterIcon from './resources/Twitter.png';
// import DevIcon from "./resources/Dev.png";
import "./css/SocialHandles.css";

function SocialHandles() {
    return (
        <div className="socialHandles">
            <ul className="socialHandles__list">
                <li className="socialHandles__listItem">
                    <img src={LinkedInIcon} className="soialHandles__listItem__Icon" alt="Linkedin" />
                    <a rel="noreferrer" target="_blank" href="https://www.linkedin.com/in/aman-b-b1250313a/">LinkedIn</a>
                </li>
                {/* <li className="socialHandles__listItem">
                    <img src={TwitterIcon} className="soialHandles__listItem__Icon" alt="Twitter" />
                    <a rel="noreferrer" target="_blank" href="https://twitter.com/_neeraj2001_">Twitter</a>
                </li>
                <li className="socialHandles__listItem">
                    <img src={FacebookIcon} className="soialHandles__listItem__Icon" alt="Facebook" />
                    <a rel="noreferrer" target="_blank" href="https://www.facebook.com/Neeraj1502/">Facebook</a>
                </li>
                <li className="socialHandles__listItem">
                    <img src={InstagramIcon} className="soialHandles__listItem__Icon" alt="Instagram" />
                    <a rel="noreferrer" target="_blank" href="https://www.instagram.com/_neeraj.gupta15_/">Instagram</a>
                </li> */}
                {/* <li className="socialHandles__listItem">
                    <img src={DevIcon} className="soialHandles__listItem__Icon" alt="Practical Dev" />
                    <a rel="noreferrer" target="_blank" href="https://dev.to/">Dev.to</a>
                </li> */}
            </ul>
        </div>
    );
}

export default SocialHandles
